
<div>
  <up-text-field
    [ngClass]="{'longWidth': fullWidth}"
    [fieldLabel]="fieldLabel"
    [errorState]="errorState"
    [fieldMessage]="errorMessageText"
  >
    <input
      id="email"
      type="email"
      [formControl]="emailControl"
      [placeholder]="placeholder"
      (input)="resetError()"
      (blur)="onBlur()"
      maxlength="100"
      autocomplete="off"
    />
  </up-text-field>
</div>
